import { render, staticRenderFns } from "./SidebarProductImageBlock.vue?vue&type=template&id=fb905786&scoped=true"
import script from "./SidebarProductImageBlock.vue?vue&type=script&lang=ts"
export * from "./SidebarProductImageBlock.vue?vue&type=script&lang=ts"
import style0 from "./SidebarProductImageBlock.vue?vue&type=style&index=0&id=fb905786&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb905786",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb905786')) {
      api.createRecord('fb905786', component.options)
    } else {
      api.reload('fb905786', component.options)
    }
    module.hot.accept("./SidebarProductImageBlock.vue?vue&type=template&id=fb905786&scoped=true", function () {
      api.rerender('fb905786', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/sidebar/SidebarProductImageBlock.vue"
export default component.exports